import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationSuccess = () => {
  return (
    <div className="h-[calc(100vh-64px)] flex items-center justify-center bg-gray-100">
      <div className="bg-white mx-auto w-full max-w-lg rounded shadow-md p-8 text-center">
        <h2 className="text-2xl font-bold mb-4 text-green-600">Registration Successful!</h2>
        <p className="text-gray-700 mb-6">
          A confirmation link has been sent to your email. 
          Follow the link to complete your registration.
        </p>
        <p className="text-gray-600">
          Once confirmed, you can <Link to="/login" className="underline decoration-solid text-blue-500">sign in</Link>.
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;